const ARABIC_PRODUCTS = {
  Badges: 'شارات',
  Bookmarks: 'فواصل كتب',
  Brochures: 'بروشورات',
  'Business Cards': 'بطاقات عمل',
  Calendars: 'تقاويم',
  Catalogues: 'كتالوجات',
  Certificates: 'شهادات',
  'Coated Paper Bags': 'أكياس ورقية مغلفة',
  Envelopes: 'أظرف',
  Flyers: 'فلايرات',
  Folders: 'ملفات',
  'ID Cards': 'بطاقات تعريف',
  Invitations: 'دعوات',
  'Kraft Paper Bags': 'أكياس ورق كرافت',
  Leaflets: 'منشورات مطوية',
  Letterheads: 'أوراق رسمية',
  Menus: 'قوائم طعام',
  'Custom Notebooks': 'دفاتر مخصصة',
  Postcards: 'بطاقات بريدية',
  'Prescription Pads': 'دفاتر روشتات',
  'Self Carbon Notebooks': 'دفاتر كربون ذاتية',
};

const ARABIC_SPECIFICATIONS = {
  'Badge Type': 'نوع الشارة',
  'Binding Type': 'نوع التجليد',
  'Cover Paper': 'ورق الغلاف',
  'Folded Size': 'الحجم المطوي',
  'Folding Type': 'نوع الطي',
  Finishing: 'التشطيب',
  'Handle Type': 'نوع المقبض',
  'Inside Paper': 'الورق الداخلي',
  Lamination: 'التغليف',
  Material: 'الخامة',
  'Number of Pages': 'عدد الصفحات',
  Packaging: 'التغليف والتعبئة',
  Paper: 'الورق',
  'Paper Type': 'نوع الورق',
  'Paper Type & Weight': 'نوع ووزن الورق',
  'Printed Colors': 'ألوان الطباعة',
  'Printed Sides': 'أوجه الطباعة',
  Shape: 'الشكل',
  Size: 'الحجم',
  'Unfolded Size': 'الحجم غير المطوي',
};

const ARABIC_VALUES = {
  'Black & White': 'أبيض وأسود',
  'Double Side': 'وجهين',
  'Full Color': 'ألوان كاملة',
  'Glossy Lamination': 'تغليف لامع',
  'Half Fold': 'طي نصف',
  'Matte Lamination': 'تغليف مطفي',
  'No Folding': 'بدون طي',
  'No Lamination': 'بدون تغليف',
  Other: 'آخر',
  'Single Side': 'وجه واحد',
  'Tri Fold': 'طي ثلاثي',
  'Z Fold': 'طي بشكل Z',
};

function localizeValue(value, language) {
  if (Array.isArray(value)) return value.map((item) => localizeValue(item, language)).join('، ');
  if (language !== 'ar') return String(value ?? '');
  return ARABIC_VALUES[value] || String(value ?? '');
}

export function localizeQuoteProduct(productType, language) {
  return language === 'ar' ? ARABIC_PRODUCTS[productType] || productType : productType;
}

export function localizeQuoteSummary(item, language) {
  if (language !== 'ar') return item.summary || '';

  const specifications = item.specifications && typeof item.specifications === 'object'
    ? item.specifications
    : {};

  return Object.entries(specifications)
    .filter(([key, value]) => key !== 'source_path' && value !== '' && value != null)
    .slice(0, 3)
    .map(([key, value]) => `${ARABIC_SPECIFICATIONS[key] || key}: ${localizeValue(value, language)}`)
    .join(' | ');
}
